import {
  Breadcrumb,
  BreadcrumbEllipsis,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { useIsMobile } from '@/hooks/common/use-mobile';
import { useBreadcrumbs } from '@/hooks/routing/use-breadcrumbs';
import { useState } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Link } from 'react-router';

const ITEMS_TO_DISPLAY = 3;

export const Breadcrumbs = () => {
  const items = useBreadcrumbs();
  const isMobile = useIsMobile();

  const [open, setOpen] = useState(false);

  if (!items.length || isMobile) return null;

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink href={items[0].path!}>{items[0].title}</BreadcrumbLink>
        </BreadcrumbItem>
        {items.length > 1 && <BreadcrumbSeparator />}
        {items.length > ITEMS_TO_DISPLAY ? (
          <>
            <BreadcrumbItem>
              {isMobile ? null : (
                <DropdownMenu open={open} onOpenChange={setOpen}>
                  <DropdownMenuTrigger className="flex items-center gap-1" aria-label="Toggle menu">
                    <BreadcrumbEllipsis className="h-4 w-4" />
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="start">
                    {items.slice(1, -ITEMS_TO_DISPLAY + 1).map((item, index) => (
                      <DropdownMenuItem key={index}>
                        <Link to={item.path!}>{item.title}</Link>
                      </DropdownMenuItem>
                    ))}
                  </DropdownMenuContent>
                </DropdownMenu>
              )}
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            {items.slice(-ITEMS_TO_DISPLAY + 1).map((item, index, array) => (
              <BreadcrumbItem key={index}>
                <BreadcrumbLink
                  asChild
                  className={`max-w-20 truncate md:max-w-none ${
                    index === array.length - 1 ? 'text-foreground font-medium' : ''
                  }`}
                >
                  <Link to={item.path!}>{item.title}</Link>
                </BreadcrumbLink>
                {index !== array.length - 1 && <BreadcrumbSeparator />}
              </BreadcrumbItem>
            ))}
          </>
        ) : (
          items.slice(1).map((item, index, array) => (
            <BreadcrumbItem key={index}>
              <BreadcrumbLink
                asChild
                className={`max-w-20 truncate md:max-w-none ${
                  index === array.length - 1 ? 'text-foreground font-medium' : ''
                }`}
              >
                <Link to={item.path!}>{item.title}</Link>
              </BreadcrumbLink>
              {index !== array.length - 1 && <BreadcrumbSeparator />}
            </BreadcrumbItem>
          ))
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
